const Strings = {
  HIDE_COMMENTS: {
    SE: 'Göm kommentarer',
    EN: 'Hide comments'
  },
  APARTMENT: {
    SE: 'Lägenhet',
    EN: 'Apartment'
  },
  SHOW_ALL_COMMENTS: {
    SE: 'Visa alla kommentarer',
    EN: 'Show all comments'
  },
  THE_BOARD: {
    SE: 'Styrelsen',
    EN: 'The board'
  },
  COMMENTS: {
    SE: 'Kommentarer',
    EN: 'Comments'
  },
  COMMENT: {
    SE: 'Kommentar',
    EN: 'Comment'
  },
  LIKE: {
    SE: 'Gilla',
    EN: 'Like'
  },
  MAKE_COMMENT: {
    SE: 'Kommentera',
    EN: 'Comment'
  },
  MISSING_COMMENT_HEADER: {
    SE: 'Kommentar saknas',
    EN: 'Comment missing'
  },
  MISSING_COMMENT: {
    SE: 'Ingen kommentar har skrivits in, var god försök igen.',
    EN: 'No comment has been written, please try again.'
  },
  OK: {
    SE: 'Okej',
    EN: 'Okey'
  },
  REQUEST_REMOVE_POST: {
    SE: 'Ta bort nyhet',
    EN: 'Remove post'
  },
  REQUEST_REMOVE_POST_INFO: {
    SE:
      'Är du säker på att du vill ta bort nyheten? Detta kan inte göras ogjort.',
    EN: 'Are you sure that you wish to remove the news? This can not be undone.'
  },
  YES: {
    SE: 'Ja',
    EN: 'Yes'
  },
  NO: {
    SE: 'Nej',
    EN: 'No'
  },
  REQUEST_REMOVE_COMMENT: {
    SE: 'Ta bort kommentar',
    EN: 'Remove comment'
  },
  REQUEST_REMOVE_COMMENT_INFO: {
    SE:
      'Är du säkrt på att du vill ta bort kommentaren? Detta kan inte göras ogjort.',
    EN:
      'Are you sure that you wish to remove the comment? This can not be undone.'
  },
  NO_POSTS: {
    SE: 'Det finns inga nyheter.',
    EN: 'There are no news.'
  },
  NO_BOOKING_SYSTEMS_ADMIN: {
    SE:
      'Inga nyheter har skickats, tryck på "förenings inställningar" för att skicka en nyhet.',
    EN: 'No news has been posted, press "association settings" to send news.'
  },
  NOT_AVAILABLE: {
    SE: 'Inte tillgänglig',
    EN: 'Not available'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/containers/FeedItems/strings.js